import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { logAPIError } from '../../../utils/logger';
import { GET_INDUSTRIES_ERROR } from './constants';

/**
 * Fetches industries per specific app (only the necessary part).
 * @param {String} locale
 * @param {Array<String>|undefined} slugs
 * @returns {Promise<Array<Industry>>}
 */
const getIndustries = (locale, slugs) => {
    const requestUrl = pathfinder('logo_maker_buyer_ajax', { endpoint: 'getIndustries' });

    return axios.post(requestUrl, { locale, slugs })
        .then(({ data }) => {
            if (data.error) {
                throw new Error(data.error);
            }

            return data;
        })
        .catch((error) => {
            logAPIError(error, { message: GET_INDUSTRIES_ERROR, slugs });

            throw new Error(GET_INDUSTRIES_ERROR);
        });
};

export default getIndustries;
